var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-240.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach-icon",
    transform: "translate(240.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.09279279 C10.9597201,1.09279279 12.5603566,2.63021249 12.6615842,4.56472663 L12.6666667,4.75945946 L12.6666667,11.2594595 C12.6666667,14.1129307 10.3534712,16.4261261 7.5,16.4261261 C4.71969472,16.4261261 2.45231395,14.2300352 2.33786596,11.4778617 L2.33333333,11.2594595 L2.33333333,4.75945946 L3.66666667,4.75945946 L3.66666667,11.2594595 C3.66666667,13.376551 5.38290846,15.0927928 7.5,15.0927928 C9.55093243,15.0927928 11.2256768,13.4821401 11.3283454,11.4567223 L11.3333333,11.2594595 L11.3333333,4.75945946 C11.3333333,3.47079504 10.2886644,2.42612613 9,2.42612613 C7.76502993,2.42612613 6.75414601,3.38555296 6.67204973,4.59970514 L6.66666667,4.75945946 L6.66666667,11.2594595 C6.66666667,11.7196968 7.03976271,12.0927928 7.5,12.0927928 C7.92483442,12.0927928 8.27541831,11.7748885 8.32684048,11.363991 L8.33333333,11.2594595 L8.33333333,5.75945946 L9.66666667,5.75945946 L9.66666667,11.2594595 C9.66666667,12.4560764 8.69661696,13.4261261 7.5,13.4261261 C6.35540987,13.4261261 5.41811378,12.5385948 5.33877345,11.4141939 L5.33333333,11.2594595 L5.33333333,4.75945946 C5.33333333,2.73441538 6.97495592,1.09279279 9,1.09279279 Z",
    id: "Path",
    fill: "#fff",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    transform: "translate(7.500000, 8.759459) rotate(-150.000000) translate(-7.500000, -8.759459) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach-icon.4d257a2f.svg";
export { ForwardRef as ReactComponent };